import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShaderEffect: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="shader-effect, material" maskId="round-filled-radius-1-stroke-1.5-IconShaderEffect"><path d="M20.5156 3.54395C20.815 3.85797 21 4.28192 21 4.75V19.25C21 20.2165 20.2165 21 19.25 21H4.75C4.28192 21 3.85797 20.815 3.54395 20.5156L20.5156 3.54395Z" fill="currentColor"/><path d="M3 18.9395V13.0605L13.0605 3H18.9395L3 18.9395Z" fill="currentColor"/><path d="M3 10.9395V4.75C3 3.7835 3.7835 3 4.75 3H10.9395L3 10.9395Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShaderEffect;
